import { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { downloadFile, errMsg } from "../lib/api";

export const ExportButton = ({ name, label = "Excel", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadFile(`/export/register/${name}`, `${name}-register.xlsx`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" className={`btn btn-outline ${className}`} onClick={run} disabled={busy} data-testid={`export-${name}-btn`}>
      {busy ? <Loader2 size={18} className="animate-spin" /> : <FileSpreadsheet size={18} />} {label}
    </button>
  );
};
